import React, { useRef, useState, useEffect } from 'react'
import Isvg from 'react-inlinesvg'
import _ from 'lodash'
import { ClearDropdown_s, CarouselDropdown_s } from 'styles/input-styles'
import { CloseIcon } from 'images/icons/general'

type DetailedOption = {
  label: string
  value: any
}

type Option = string | DetailedOption

const isDetailedOption = (opt: Option): opt is DetailedOption => {
  return (opt as DetailedOption)?.label !== undefined
}

interface DropdownProps {
  attrs?: Function
  data: {} | []
  default?: string
  disabled?: boolean
  disabledText?: string
  field: string | string[]
  filter?: boolean
  filterPlaceholder?: string
  onFocus?: Function
  onClear?: Function
  options: Option[]
  persist: Function
  className: string
}

const DropdownInput = (props: DropdownProps) => {
  const dropdownRef = useRef(null);
  const [dropUp, setDropUp] = useState(false);

  let initialValue = _.get(props.data, props.field)
  if(_.isArray(props.field)) {
    let row = _.get(_.get(props, "data.items"), props.field[0])
    if(row) initialValue = row[props.field[1]]
  }
  const [val, updateVal] = useState<string | null>(_.isNil(initialValue) ? null : initialValue)

  useEffect(() => {
    if (_.isNil(initialValue) && !_.isNil(val)) {
      updateVal(null)
    }
    if (!_.isNil(initialValue)) {
      updateVal(initialValue)
    }
  }, [initialValue])

  const attrs = (props.attrs && props.attrs(props.field)) || {}

  let options = _.get(props, "options")?.filter((o) => o !== undefined)
  options = _.isNil(options) || _.get(options, "length") === 0
    ? []
    : isDetailedOption(_.get(options, "[0]"))
      ? options
      : options.filter((o) => o !== undefined).map((option) => ({ label: option, value: option }))

  const currentSelected = isDetailedOption(_.get(options, "[0]"))
    ? _.get(_.find(options, { value: val }), "label", "")
    : _.get(options, `[${val}]`, "")

  useEffect(() => {
    const findContainerBottom = () => {
      const carouselContainer = document.querySelector('#carousel-content-container')
      return _.get(_.invoke(carouselContainer, "getBoundingClientRect"), "bottom")
    }

    if (dropdownRef.current) {
      const rect = _.invoke(dropdownRef.current, "getBoundingClientRect")
      const viewportBottom = findContainerBottom()
      const dropdownHeight = 24*_.clamp(props.options.length, 1, 10)+20
      setDropUp(rect.bottom + dropdownHeight > viewportBottom)
    }
  }, [dropdownRef])

  return (
    <div ref={dropdownRef}>
      <span {...attrs} style={{display: 'flex'}} title={currentSelected}>
        <CarouselDropdown_s
          className={`${props.className} ${dropUp ? 'drop-up' : ''}`}
          disabled={props.disabled || false}
          filter={props.filter}
          filterPlaceholder={props.filterPlaceholder}
          value={(props.disabled && props.disabledText) ? null : _.isNil(val) ? props.default : val}
          options={options}
          onFocus={props.onFocus}
          onChange={(e) => {
            updateVal(e.value)
            props.persist(e.value, props.field)
          }}
          placeholder={props.disabled && props.disabledText ? props.disabledText : ''}
        />
        { props.onClear && !_.isNil(val) && <ClearDropdown_s onClick={props.onClear}><Isvg src={CloseIcon} /></ClearDropdown_s>}
      </span>
    </div>
  )
}

export default DropdownInput
